import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const WORDS = "We built a serious foodservice distribution company — one warehouse, one account, one partner for the products, packaging and supplies your kitchen runs on.".split(" ");

export default function OneStop() {
  return (
    <section data-testid="one-stop-shop" className="py-24 md:py-36 bg-skyblue relative overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <Reveal>
          <span className="overline text-forest/60">Your Restaurant Supply Partner</span>
        </Reveal>
        <motion.p
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          transition={{ staggerChildren: 0.035 }}
          className="font-display text-3xl sm:text-5xl lg:text-[4rem] leading-[1.08] tracking-tight text-forest mt-6 max-w-6xl"
        >
          {WORDS.map((w, i) => (
            <motion.span
              key={i}
              variants={{ hidden: { opacity: 0.15 }, show: { opacity: 1 } }}
              transition={{ duration: 0.4 }}
              className="inline-block mr-[0.28ch]"
            >
              {w}
            </motion.span>
          ))}
        </motion.p>
      </div>
    </section>
  );
}
